import { Company } from '../../models/company';

export interface CompaniesState {
  companies: Company[]
}

export const initialCompaniesState: CompaniesState = {
  companies: []
};
